import $ from "jquery";
import React, { useState, useEffect } from 'react';
import SessionManager from '../../routes/SessionManager';

function ZoneSensorBattery(props) {

    const [batteryClassName, setBatteryClassName] = useState('fa fa-battery text-white');
    let user = new SessionManager().readCookie('user');

    useEffect(() => {
        fetchSensorInfo();
    }, [props]);

    const fetchSensorInfo = () => {
        var sensor_name = props.sensor_name;

        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
        }

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/sensor-info/' + sensor_name,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    if (res.data.length > 0) {
                        var c = res.data[0]['sensor_vcc'] / 1024;
                        var batteryClass = c > 3 ? 'fa-battery text-success' : c > 2.9 ? 'fa-battery-2 text-warning' : 'fa-battery-1 text-danger';
                        setBatteryClassName('fa ' + batteryClass);
                    }
                }
            },
            (res) => {

            });
    }

    return (
        <i className={batteryClassName}></i>
    );
}

export default ZoneSensorBattery;